module.exports = __webpack_public_path__ + "img/about-processing.012727d0.png";